import { Component, OnInit, ViewChild ,Inject} from "@angular/core";
import {
  UntypedFormGroup,
  UntypedFormControl,
  Validators,
  ValidationErrors
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { ReportlinksserviceService } from "../../reportlinks/reportlinksservice.service";

export interface FormData {
  instancedetailid: any;
}
@Component({
    selector: 'app-senttovaultcomponent',
    templateUrl: './senttovaultcomponent.component.html',
    styleUrls: ['./senttovaultcomponent.component.scss'],
    standalone: false
})
export class SenttovaultcomponentComponent implements OnInit {

  FormValid: UntypedFormGroup;
  instancedetailId;

  //choose image
  imagephoto;
  imagephotoshow: any = false;
  backgroundColorScreen = "";
  backgroundColorButton = "";
  sendtovault={"fileName":"","fileData":""}

  constructor(
    private dialogref: MatDialogRef<SenttovaultcomponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FormData,
    private snackbar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private dialog: MatDialog,
    private localStorageSettings: LocalStorageSettingsService,
    private reportlinksserviceService:ReportlinksserviceService,
  )  { }

  ngOnInit() {
    this.instancedetailId = this.data.instancedetailid;
    this.formvalidations();
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl("")
    });
  }

  // event on input type file
  imagePhotofunction($event): void {
    this.readThisimage($event.target);
  }

  // to encode the selected photo
  readThisimage(inputValue: any): void {
    var file: File = inputValue.files[0];
    var FileS: File = inputValue.files[0];
    if (file.type === 'application/pdf') {

      console.log(file.size / 1000)
      var size = file.size / 1000
      if (size <= 3072) {
            var fileName = FileS.name;
            //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

            var photo: FileReader = new FileReader();
            photo.onloadend = e => {
              var img = photo.result;
              console.log(photo.result);
              var photobase64result = photo.result.toString().split(",", 2)[1];

              // this is to check the file is empty or not
              if (photobase64result == null) {
                
              } else {
                this.imagephoto = photo.result.toString();
                this.imagephotoshow = true;
                this.sendtovault.fileData = photobase64result;
                this.sendtovault.fileName = fileName;
                this.FormValid.controls.imageName.setValue(fileName);
                // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
              }
            };
                photo.readAsDataURL(file);
      } else {
        this.snackbar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
          duration: 5000,
        });
        (<HTMLInputElement>document.getElementById('govtIdProofName'));
      }
    } else {
      this.snackbar.open(file.name + " is a invalid image type ", "OK", {
        duration: 5000,
      });
      (<HTMLInputElement>document.getElementById('govtIdProofName')).value = null;
    }
  }

  //delete attachements
  deleteimage() {
    this.imagephoto = "";
    this.imagephotoshow = false;             
    this.sendtovault.fileData = "";
    this.sendtovault.fileName = "";
    this.FormValid.controls.imageName.setValue(null);
    this.FormValid.controls.imageupload.setValue(null);
  }

  uploadtovault(){
    console.log(this.sendtovault)
    console.log(this.instancedetailId)
        this.reportlinksserviceService.insertToVault(this.sendtovault,this.instancedetailId).subscribe(response=>{
        this.spinner.start();
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
  
        } else {
  
          console.log(response)
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
  
        }
        this.spinner.stop();
        this.dialogref.close();
      });

  }

}
